/**
 * Button — Figma-aligned component.
 *
 * Variants:
 *   "primary"   — midnight-ink fill, cream Fraunces text
 *   "secondary" — cream fill, midnight-ink border, Fraunces text
 *   "utility"   — cream fill, midnight-ink border, Nunito text
 *   "back"      — secondary with smaller padding (44px height)
 */
import audioManager from '../../lib/audioManager';
import s from './Button.module.css';

const VARIANT_CLASS = {
  primary: s.btnPrimary,
  secondary: s.btnSecondary,
  utility: s.btnUtility,
  back: s.btnBack,
};

export default function Button({
  variant = 'primary',
  children,
  style,
  className = '',
  onClick,
  ...props
}) {
  const variantClass = VARIANT_CLASS[variant] || s.btnPrimary;

  // Subtle global click confirm (audio-system.md → button-tap). Fired before the
  // handler so it lands even if onClick navigates away; never blocks the handler.
  const handleClick = (e) => {
    audioManager.playSFX('button-tap');
    if (onClick) onClick(e);
  };

  return (
    <button
      className={`${s.btn} ${variantClass} ${className}`}
      style={style}
      onClick={handleClick}
      {...props}
    >
      {children}
    </button>
  );
}
